module.exports = __webpack_public_path__ + "static/doppio@2x-6215bfbe81c143cda877eb19e1cf3967.png";